import {
  User,
  MonitorSmartphone,
  Bell,
  Building2,
  CreditCard,
  type LucideIcon,
} from "lucide-react"
import { SettingsSectionHeader } from "../components/SettingsSectionHeader"

type PlaceholderSection =
  | "profile"
  | "sessions"
  | "notifications"
  | "general"
  | "plan"

const CONFIG: Record<
  PlaceholderSection,
  { title: string; description: string; icon: LucideIcon }
> = {
  profile: {
    title: "Profile",
    description: "Manage your personal account details",
    icon: User,
  },
  sessions: {
    title: "Sessions",
    description: "Review and revoke active login sessions",
    icon: MonitorSmartphone,
  },
  notifications: {
    title: "Notifications",
    description: "Choose what updates you want to receive",
    icon: Bell,
  },
  general: {
    title: "General",
    description: "Manage your organization's basic information",
    icon: Building2,
  },
  plan: {
    title: "Plan and Pricing",
    description: "Manage your subscription and billing",
    icon: CreditCard,
  },
}

export function SettingsPlaceholder({ section }: { section: PlaceholderSection }) {
  const { title, description, icon: Icon } = CONFIG[section]

  return (
    <div className="h-full overflow-y-auto">
      <div className="mx-auto max-w-3xl px-6 py-8 lg:px-8">
        <SettingsSectionHeader title={title} description={description} />

        <div className="mt-6 flex flex-col items-center justify-center rounded-2xl border border-dashed border-border bg-muted/20 px-6 py-16 text-center">
          <div className="mb-4 flex size-12 items-center justify-center rounded-xl bg-muted">
            <Icon className="size-6 text-muted-foreground" />
          </div>
          <p className="font-medium text-foreground">Coming soon</p>
          <p className="mt-1 max-w-sm text-sm text-muted-foreground">
            {title} settings are under development. Check back later for updates.
          </p>
        </div>
      </div>
    </div>
  )
}
